import React from 'react'
import { Route, Switch } from 'react-router'
import ReportCarrierUsage from './ReportCarrierUsage'

const Components = props => (
    <Switch>
        <Route exact path={props.match.url} component={ReportCarrierUsage} />
    </Switch>
)

export default Components
